import { Injectable } from '@angular/core';
import { EstrategiasReportes, ServicioReportes } from '../core/servicio-reportes';
import { ReporteRegistrado } from '../core/reporte';
import { ReportesApiService } from '../reportes-api.services';
import { FormatoReportePrevired, PREVIRED_REPORTES_DATOS } from './tipos-reporte';
import { parsearPagosNominasPrevired, parsearTrabajadorCasaParticular } from './reportes-parser';

@Injectable({ providedIn: 'root' })
export class PreviredReportesService extends ServicioReportes<'PREVIRED', typeof PREVIRED_REPORTES_DATOS> {
    constructor(api: ReportesApiService) {
        const estrategias = {
            pagosnominas: {
                consultar: ({ idcliente, anio }) => api.obtenerPagosNominasPrevired(idcliente, anio),

                transformar: (dto) => {
                    const data = parsearPagosNominasPrevired(dto)
                    return {
                        data: data
                    };
                },
            },
            previred_tcp: {
                consultar: ({idcliente, anio}) => api.obtenerTCP(idcliente, anio),
                transformar: (dto) => {
                    const data = parsearTrabajadorCasaParticular(dto)
                    return {data: data}}
            }
        } satisfies EstrategiasReportes<typeof PREVIRED_REPORTES_DATOS>;

        super(
            {
                codigo: 'PREVIRED',
                nombre: 'Previred',
                ruta: '/previred-reportes',
                icono: 'pi pi-wallet',
                permiso: 'reportes.ver'
            },
            PREVIRED_REPORTES_DATOS,
            estrategias
        );
    }
}

export type ReportePrevired = ReporteRegistrado<FormatoReportePrevired>;
